import '@babel/polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import stores from './stores'
import component from './components'
import outMsg from '@/mixins/message-mixins'
import './filters'
import '@/assets/css/temp.css'
import array from 'lodash/array'
import Lang from 'lodash/lang'
import i18n from './i18n'
import ElementUI from '@jd/element-ui'
import VueCookie from 'vue-cookie'
import enLocale from '@jd/element-ui/lib/locale/lang/en'

import { clstagcontent } from '@/statistics'

window.toRoutePath = function(url) {
  if (!url || url.length <= 0) {
    return
  }
  if (url.charAt(0) !== '/') {
    url = '/' + url
  }
  router.push(url)
}

Vue.config.productionTip = process.env.NODE_ENV === 'development'

Vue.use(VueCookie)
if (VueCookie.get('jdcloud_sitelang') === 'en') {
  document.title = 'JD Cloud Console'
  ElementUI.locale(enLocale)
}

Vue.prototype.$array = array
Vue.prototype.$lang = Lang
Array.prototype.pushNoRepeat = function() {
  for (var i = 0; i < arguments.length; i++) {
    var ele = arguments[i]
    if (this.indexOf(ele) == -1) {
      this.push(ele)
    }
  }
}

Vue.prototype.clstagcontent = clstagcontent
Vue.prototype.lang = VueCookie.get('jdcloud_sitelang')

Vue.use(component)
Vue.mixin(outMsg)

new Vue({
  el: '#app',
  store: stores,
  router,
  components: {
    App
  },
  template: '<App/>',
  i18n
})
